import axiosInstance from "../axiosInstance";

export const childTransfer = {
  post: (path, params, headers, cancelToken) =>
    axiosInstance
      .post(`/Transfers${path}`, params, {
        cancelToken: cancelToken?.token,
        headers,
      })
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
        // if (res?.data?.error || res?.data?.status === 'error') throw res.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
  get: (path, params, headers, cancelToken) =>
    axiosInstance
      .get(
        `/Transfers${path}`,
        { params },
        {
          cancelToken: cancelToken?.token,
          headers,
        }
      )
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
};

// export const getAdditionalInstitutes = async (params) =>
//   applicationsApi.post("/GetAdditionalInstitutes", JSON.stringify(params), {
//     "Content-Type": "application/json",
//   });

// export const getEligibleApplications = async () =>
//   disbursementApi.get("/GetEligibleApplications");

// export const getDisbursementApplications = async () =>
//   disbursementApi.get("/GetDisbursements");

// export const createDisbursement = async (params) =>
//   disbursementApi.post("/Create", JSON.stringify(params), {
//     "Content-Type": "application/json",
//   });

export const getTransfer = async (id) =>
  childTransfer.get(`/GetTransfer/${id}`);

// // export const getApplication = async (id) =>
// //   applicationsApi.get(`/GetApplication/${id}`);

// // export const getAmkaRegistryInfo = async (params) =>
// //   applicationsApi.get("/GetAmkaRegistryInfo", params);

export const updateTransfer = async (params) => {
  return childTransfer.post("/Update", JSON.stringify(params), {
    "Content-Type": "application/json",
  });
};

export const getAvailableApartments = async (id) =>
  childTransfer.get(`/GetAvailableApartments/${id}`);

export const searchAvailableApartments = async (params) =>
  childTransfer.post("/SearchAvailableApartments", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const getApartmentSearchLookups = async () =>
  childTransfer.get("/GetApartmentSearchLookups");

export const getChildInstitutes = async () =>
  childTransfer.get(`/GetChildInstitutes`);

// export const getAmendmentStatus = async (id) =>
//   disbursementApi.get(`/GetAmendmentStatus/${id}`);

// export const amendApplication = async (params) => {
//   return disbursementApi.post("/AmendApplication", JSON.stringify(params), {
//     "Content-Type": "application/json",
//   });
// };
